export interface RootFolder {
    id: 'root';
    hash: 'root';
    path: '';
}

export const ROOT_FOLDER: RootFolder = {
    id: 'root',
    hash: 'root',
    path: '',
};
